var lib_core = require("lib-core");
var IpcSmdPadGeneratorWithThermalPadInteractionModel = require('../ipcSmdPadGeneratorWithThermalPadInteractionModel.js');
var PackageGeneratorInspectorConfig = require("../../packageGeneratorInspectorConfig.js");
var IpcImages = require("../../../../../shared/extensions/footprintGenerator/ipcImages/index.js");

var SonPadGeneratorInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    IpcSmdPadGeneratorWithThermalPadInteractionModel.call(this, parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams);
};

lib_core.inherit(SonPadGeneratorInteractionModel, IpcSmdPadGeneratorWithThermalPadInteractionModel);
SonPadGeneratorInteractionModel.$class = 'SonPadGeneratorInteractionModel';
module.exports = SonPadGeneratorInteractionModel;

SonPadGeneratorInteractionModel.prototype.getInspectorElementForBodyWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('E', this.LCLZ('bodyWidth', 'Body Width'), false, this.bodyWidthMin, false, this.bodyWidthMax, this.userSettingsModel.distanceUnit)];
};

SonPadGeneratorInteractionModel.prototype.getInspectorElementForBodyLength = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('D', this.LCLZ('bodyLength', 'Body Length'), false, this.bodyLengthMin, false, this.bodyLengthMax, this.userSettingsModel.distanceUnit)];
};

SonPadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    //custom footprint settings
    if (this.withCustomFootprintParams() && this.showFootprintParams()) {
        imElements = imElements.concat(this.getInspectorElementForEnablingCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintImage(IpcImages.customFootprintSon));
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintNormalPadSettings());
        imElements = imElements.concat(this.getInspectorElementForPadSpan1InCustomFootprint());
    };
    imElements = imElements.concat(this.getInspectorElementForPadCount());
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForPitch());
    imElements = imElements.concat(this.getInspectorElementForTerminalLength());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    
    imElements = imElements.concat(this.getInspectorElementForEnablingThermalPad());
    imElements = imElements.concat(this.getInspectorElementForThermalPadSize());
    imElements = imElements.concat(this.getInspectorElementForThermalPadSolderPasteOverride());
    imElements = imElements.concat(this.getInspectorElementForThermalPadSolderPastePattern());
    imElements = imElements.concat(this.getInspectorElementForThermalPadSolderPasteCoverageArea());
    
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForTolerance());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};